import { Dropdown,Tooltip } from 'bootstrap';
import { useContext, useEffect, useRef, useState } from 'react';
import { SmartContext } from '../../../library/Core/SmartContext';
import useSmartState from '../../../common/hooks/useSmartState';
import { REPORT_CONFIG } from '../reports/report-config';
import ActionSettings from '../../../library/SimpleControls/ActionSettings';
import Swal from 'sweetalert2';
import { FormControl } from '../../../library/Core/SmartTypes';
import { axiosClient } from '../../../library/Service/axiosClient';

const BATCH_SIZE = 10;
const DEFAULT_SORT_COLUMN = 'createdAt';
const DEFAULT_SORT_DIRECTION = 'desc';

const ContactGrid = () => {
    const { state, dispatch } = useContext(SmartContext);
    const { setStateValue } = useSmartState();
    const [sortedStudents, setSortedStudents] = useState<string[]>([]);
    const [visibleStudents, setVisibleStudents] = useState(state.data.contactList.slice(0, 10));
    const loadMoreRef: any = useRef();
    const dropdownRef = useRef(null);
    const [sortColumn, setSortColumn] = useState(DEFAULT_SORT_COLUMN);
    const [sortDirection, setSortDirection] = useState(DEFAULT_SORT_DIRECTION);
    const allRows = [...state.data.contactList] ?? [];
    const config = REPORT_CONFIG[state.routeInfo.pageName];

    useEffect(() => {
        console.log(state.data.alumniList);
        console.log(`useEffect 1`);
        if (dropdownRef.current) {
            new (Dropdown as any)(dropdownRef.current);
        }
    }, []);

    useEffect(() => {
        console.log(`useEffect 2`);
        const sorted = [...allRows].sort(compareFunction);
        setSortedStudents(sorted);
    }, [state.data.contactList, sortColumn, sortDirection]);

    useEffect(() => {
        console.log(`useEffect 3`);
        setVisibleStudents(sortedStudents.slice(0, BATCH_SIZE));
    }, [sortedStudents]);

    useEffect(() => {
        console.log(`useEffect 4`);
        const loadMoreObserver = new IntersectionObserver((entries) => {
            // Check if all students are already visible
            if (sortedStudents.length <= visibleStudents.length) {
                if (loadMoreRef.current) {
                    loadMoreObserver.unobserve(loadMoreRef.current); // Stop observing
                }
                return;
            }

            if (entries[0].isIntersecting) {
                const nextBatch = sortedStudents.slice(0, visibleStudents.length + BATCH_SIZE);
                setVisibleStudents([...nextBatch]);
            }
        });

        if (loadMoreRef.current) loadMoreObserver.observe(loadMoreRef.current);
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new Tooltip(tooltipTriggerEl);
        });

        return () => {
            if (loadMoreRef.current) {
                loadMoreObserver.unobserve(loadMoreRef.current);
            }
        };
    }, [loadMoreRef, visibleStudents]);


    // Utility to determine if the column is a string type.
    const isStringColumn = typeof visibleStudents[0]?.[sortColumn] === 'string';

    const compareFunction = (a: any, b: any) => {
        const aValue = a[sortColumn];
        const bValue = b[sortColumn];

        if (isStringColumn) {
            return sortDirection === 'asc'
                ? aValue?.localeCompare(bValue, undefined, { sensitivity: 'accent' })
                : bValue?.localeCompare(aValue, undefined, { sensitivity: 'accent' });
        } else {
            return sortDirection === 'asc' ? (aValue > bValue ? 1 : -1) : aValue < bValue ? 1 : -1;
        }
    };

    const deleteInstituteContact = async (uuid: string) => {
      try {
        await axiosClient().post(`${process.env.REACT_APP_ADMIN_API_SERVER}/institute/delete-contact/${uuid}`);
      } catch (error) {
          console.error('Failed to delete institute contact:', error);
      }
    }

    const getActionNode = (row: any) => {
        // Define actions as an array
        const actions = ['Edit','Delete']; 
        if (row.userStatusCode === 1) {
            actions.push('IMPERSONATE_USER_(_READONLY_)');
        }
        // Check if actions array has any elements
        return actions.length > 0 ? (
            <ActionSettings id={row} actions={actions} onClick={handleAction} />
        ) : null;
    };

    const handleAction = (row: any, action: string) => {
        handlePerformAction(action, row);
    };
    
    const handlePerformAction = async (action: string, row: any) => {

       const instituteId =  row.primaryInstituteId;
       const uUID    =  row.uUID;
       const groupId = state?.data?.groupId;
        switch (action) {
            case 'EDIT':
                window.open(`${process.env.REACT_APP_APP_BASE_URL}/institute/${uUID}/${instituteId}/${groupId}/contact-edit`);
                break;
             case 'DELETE':
              const msg= 'Are you sure you want to Delete this record?';
              const isConfirmed = window.confirm(msg);
              if (isConfirmed) {
                try {
                  await deleteInstituteContact(uUID);
                  const updatedContacts = state.data.contactList.filter((contact: any) => contact.uUID !== uUID);
                  setStateValue('contactList',updatedContacts);
                } catch (error) {
                  console.error('Failed to delete institute contact:', error);
                }
              }
              break;
            case 'IMPERSONATE_USER_(_READONLY_)': //@UAS-2071
              Swal.fire({
                  title: 'Initializing Impersonation Session...',
                  allowOutsideClick: false,
                  didOpen: () => {
                      Swal.showLoading();
                  }
              });
                localStorage.setItem('user-main', localStorage.getItem('user') || '');
                localStorage.setItem('token-main', localStorage.getItem('user-jwt-token') || '');
                localStorage.setItem('url-main', window.location.href);
                localStorage.setItem('pendingToastData', JSON.stringify({ message: `You are now impersonating ${row?.firstName} ${row?.lastName}` }));

                localStorage.setItem('univariety-user-main', localStorage.getItem('univariety-user') || '');
                localStorage.removeItem('univariety-user');

                window.location.href = `${process.env.REACT_APP_APP_BASE_URL}/ssoi/${row?.hash}/aW1wZXJzb25hdGU=/bWFuYWdlbWVudC9kYXNoYm9hcmQ=`;
              break;

            default:
                console.log('Action not recognized:', action);
        }
    };
    
    
    return (
        <> 
         <div>
            <div className="ActiveListings_present">
                <div className="d-flex flex-wrap align-items-center mb-3 w-100 justify-content-between mailerLinks-parent">
                <div className="d-flex flex-wrap align-items-center flex-1 mailerLinks my-2">
                            <div className="d-flex justify-content-start align-items-center customselect_parnt">
                            </div>
                    </div>
                    <div className="d-flex flex-wrap align-items-center justify-content-end">
                        <h3 className="font-14 font-500 mb-0 me-2">Total {state.data.contactList && state.data.contactList.length} records</h3>
                    </div>
                </div>
                <div className="table-responsive attendee_dtl">
                    <table className="table" style={{ minWidth: '1042px' }}>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Contact Details</th>
                                <th>Designation</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                        {visibleStudents.map((row: any) => (
                            <tr key={row.id}>
                            <td>{row.firstName} {row.lastName}</td>
                            <td>
                                <div className="d-flex flex-column">
                                    <div className="d-flex flex-wrap align-items-center"><i className="icon-phone me-2"></i><span>+{row.mobileCountryCode} {row.mobileNumber}</span></div>
                                    <div className="d-flex flex-wrap align-items-center"><i className="icon-mail me-2"></i><span>{row.registeredEmailId}</span></div>
                                </div>
                                </td>
                                <td>{row.designation}</td>
                                <td>{getActionNode(row)}</td>
                            </tr>
                          ))}
                        <tr ref={loadMoreRef} />
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        </>
        );
    };
    
export default ContactGrid;
